import { ref } from "vue";

export function useLoading(initialState = false, minLoadingTime = 500) {
  const isLoading = ref<boolean>(initialState);

  const startLoading = () => {
    isLoading.value = true;
  };

  const stopLoading = () => {
    isLoading.value = false;
  };

  const withLoading = async <T>(fn: () => Promise<T>): Promise<T> => {
    try {
      startLoading();
      const [result] = await Promise.all([
        fn(),
        new Promise((resolve) => setTimeout(resolve, minLoadingTime)),
      ]);
      return result;
    } finally {
      stopLoading();
    }
  };

  return {
    isLoading,
    startLoading,
    stopLoading,
    withLoading,
  };
}
